<template>
	<EMCoreTemplate category="OSMGI" identity="loanContract" entity="osm_loan_contract"></EMCoreTemplate>
</template>
<script type="text/javascript">
	import {EMCoreTemplate} from '@/Adm/components' 
	export default{
		components:{
			EMCoreTemplate
		}	
	}

</script>


// WEBPACK FOOTER //
// src/Adm/EntityManagementGI/containers/LoanContract.vue